import { type FC } from 'react';
import { useModal } from '~/modal/useModal.hook';
import { MapListSortType } from './mapListing.helpers';
import { MobileMapListingComponent } from './mobileMapListing.component';
import { useMapListingToggleManagement } from './useMapListingToggleManagement.hook';

export const MobileMapListingContainer: FC = () => {
  const {
    selectedMapIds, selectedSubMapIds, onToggleShowSubMaps, mapListingItems, pagination, onPageChange,
    isLoading: isMapListingDataLoading, errorMessage, toggledMapIds,
  } = useMapListingToggleManagement(MapListSortType.Updated_DESC);

  const { openModal: openShareSettingsModal } = useModal('ShareMap');

  return (
    <MobileMapListingComponent
      errorMessage={errorMessage}
      isMapListingDataLoading={isMapListingDataLoading}
      processedItems={mapListingItems}
      selectedMapIds={selectedMapIds}
      selectedSnapshotIds={selectedSubMapIds}
      toggledMapIds={toggledMapIds}
      toggleSubMapVisibility={onToggleShowSubMaps}
      pagination={pagination}
      onPageChange={onPageChange}
      onMapShareSettingsClick={openShareSettingsModal}
    />
  );
};
